import React, { useContext, useEffect, useMemo, useState } from 'react'
import { LangContext } from '../../context/lang-context'
import FormSkel from './FormSkel'

const emptyData = {
  Name: "",
  ManufacturerName: "",
  ManufacturerId: null
}

const norm = (s) => String(s ?? "").trim().toLowerCase()

export default function MachineTypeForm({ machineTypeData, handleSubmit, handleClose, manufacturers }) {
  const { TRL_Pack } = useContext(LangContext)
  const [data, setData] = useState(emptyData)


  useEffect(() => {
    if (!machineTypeData) {
      setData(emptyData)
      return
    }

    const manufacturerName =
      manufacturers.find(m => Number(m.ManufacturerId) === Number(machineTypeData.ManufacturerId))?.Name || ""

    setData({
      ...machineTypeData,
      ManufacturerName: manufacturerName
    })
  }, [machineTypeData, manufacturers])

  const manufacturerMap = useMemo(() => {
    const map = new Map()
    ;(manufacturers || []).forEach(m => {
      map.set(norm(m.Name), Number(m.ManufacturerId))
    })
    return map
  }, [manufacturers])

  const manufacturerInvalid =
    norm(data.ManufacturerName) !== "" && !data.ManufacturerId

  return (
    <FormSkel
      headerText={machineTypeData ? "Edytuj typ automatów" : "Nowy typ automatów"}
      handleClose={handleClose}
      data={data}
      disableSubmit={!norm(data.Name) || manufacturerInvalid}
    >
      <form
        onSubmit={evt => handleSubmit(evt, setData)}
        id="modal-form"
        autoComplete="off"
      >
        <div>
          <label className="h6">Nazwa typu automatu</label>
          <input
            className="form-control"
            name="name"
            value={data.Name || ""}
            onChange={(evt) => {
              const value = evt.target.value
              setData(prev => ({ ...prev, Name: value }))
            }}
          />
        </div>

        <div className="mt-2">
          <label className="h6">Producent</label>

          <input
            type="hidden"
            name="manufacturerId"
            value={data.ManufacturerId ?? ""}
          />

          <input
            className={`form-control ${manufacturerInvalid ? "invalid-input" : ""}`}
            name="manufacturer"
            value={data.ManufacturerName || ""}
            onChange={(evt) => {
              const value = evt.target.value
              const id = manufacturerMap.get(norm(value)) ?? null
              
              setData(prev => ({
                ...prev,
                ManufacturerName: value,
                ManufacturerId: id
              }))
            }}
            list="manufacturers"
            placeholder="Wybierz z listy…"
          />

          <datalist id="manufacturers">
            {(manufacturers || []).map(m => (
              <option key={m.ManufacturerId} value={m.Name} />
            ))}
          </datalist>
        </div>
      </form>
    </FormSkel>
  )
}
